// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-div{display:flex;gap:20px}.date-opened-field{width:50%}.fix-modal-size{padding-bottom:50px}", ""]);
// Exports
module.exports = exports;
